import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  ReportsJournalSelect,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { toWords } from "number-to-words";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export default function CheckVoucher() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
//#endregion






//#region Journal 
  const AP_DOCUMENT_TYPE = 1;
  const [journal, setJournal] = useState(null);
  const [company, setCompany] = useState(null);
  const [showJournalSelect, setShowJournalSelect] = useState(false);

  const openJournalSelect = () => {
    setShowJournalSelect(true)
  }
  const closeJournalSelect = () => {
    setShowJournalSelect(false)
  }
//#endregion








//#region Generate
  const fetchReportData = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Report/report-data/documentId/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const generateHandleClick = async () => {
    if (!journal || !company) {
      setFailMessage("Please fill up required fields")
      return;
    }

    setLoading(true)

    const _data = await fetchReportData(journal);
    console.log({_data})

    try {
      // Load the existing PDF template
      const pdfUrl = `${window.location.origin}/docs/CHECK_VOUCHER_2.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      let page = pdfDoc.getPages()[0];

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      // Helper function to wrap text
      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];

        // Split after delimiters while keeping them
        const tokens = text.match(/[^,\s/\\-]+[,\s/\\-]*/g) || [text];

        const lines = [];
        let currentLine = "";

        for (const token of tokens) {
          const testLine = currentLine + token;

          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) {
              lines.push(currentLine.trimEnd());
            }
              currentLine = token;
          }
        }

        if (currentLine) {
          lines.push(currentLine.trimEnd());
        }

        return lines;
      };

      // Header Info
      page.drawText(company.name?.toString() ?? "", {
        x: 25, y: 741, size: 16, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(company.address?.toString() ?? "", {
        x: 25, y: 731, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(company.tin?.toString() ?? "", {
        x: 25, y: 721, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(_data.company?.companyName1?.toString() ?? "", {
        x: 85, y: 612, size: 10, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(_data.remarks?.toString() ?? "", {
        x: 85, y: 588, size: 10, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(FormatDateToMDY(_data.documentDate), {
        x: 405, y: 588, size: 10, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(_data.documentNumber?.toString() ?? "", {
        x: 400, y: 612, size: 10, font: calibriBold, color: rgb(0, 0, 0),
      });

      // TABLE LOGIC
      let yPosition = 520;
      const colReferenceNumber = 60;
      const colWidthHeader = 200; 
      const lineHeight = 10;

      var maxTotalAmount = 0;
      var maxTotalApplied = 0;

      for (let index = 0; index < _data?.reference?.length; index++) {
        const itemData = _data?.reference[index];

        let particulars = _data?.particulars?.length > 0 
          ? _data.particulars.map(item => `${item.itemCode} - ${item.itemDescription} Qty: ${item.receivedQty}`).join(', ')
          : "No items received";

        if(_data?.documentSubType === "Expense"){
          particulars = _data?.particulars?.length > 0 
          ? _data.particulars.map(item => item.accountName).join(', ')
          : "No items received";
        }

        const docNoString = `${particulars}`;
        const docReferenceNumberString = `${itemData.referenceNumber?.toString()}`;
        const docNoLines = wrapText(docNoString, colWidthHeader, calibriFont, 9);
        const docReferenceNumberLines = wrapText(docReferenceNumberString, colReferenceNumber, calibriFont, 9);

        const maxLines = Math.max(docNoLines.length, docReferenceNumberLines.length);

        for (let j = 0; j < docNoLines.length; j++) {
          page.drawText(docNoLines[j], {
            x: 40,
            y: yPosition - (j * lineHeight),
            size: 10,
            font: calibriFont,
            color: rgb(0, 0, 0),
          });
        }

        for (let j = 0; j < docReferenceNumberLines.length; j++) {
          page.drawText(docReferenceNumberLines[j], {
            x: 275,
            y: yPosition - (j * lineHeight),
            size: 10,
            font: calibriFont,
            color: rgb(0, 0, 0),
          });
        }

        // Draw Amount (Keep it aligned with the top of the row)
        //page.drawText(`${itemData.referenceNumber?.toString() ?? ""}`, { x: 275, y: yPosition, size: 10, font: calibriFont, color: rgb(0, 0, 0) });
        page.drawText(`${FormatDateToMDY(itemData.referenceDate)}`, { x: 365, y: yPosition, size: 10, font: calibriFont, color: rgb(0, 0, 0) });
        page.drawText(FormatValueToDecimal(itemData.totalAmount)?.toString() ?? "", { x: 433, y: yPosition, size: 10, font: calibriFont, color: rgb(0, 0, 0) });
        page.drawText(FormatValueToDecimal(itemData.amountPaid)?.toString() ?? "", { x: 510, y: yPosition, size: 10, font: calibriFont, color: rgb(0, 0, 0) });

        maxTotalAmount += itemData.totalAmount ?? 0
        maxTotalApplied += itemData.amountPaid ?? 0
        // Adjust yPosition for the next entry
        const dynamicIncrement = Math.max(20, (maxLines * lineHeight) + 5);
        yPosition -= dynamicIncrement;
      }

      // Footer Amounts
      page.drawText(FormatValueToDecimal(maxTotalAmount)?.toString() ?? "", {
        x: 433, y: 280, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(FormatValueToDecimal(maxTotalApplied)?.toString() ?? "", {
        x: 510, y: 280, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(_data.bankName?.toString() ?? "", {
        x: 335, y: 225, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(_data.checkbookNumber?.toString() ?? "", {
        x: 450, y: 225, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(FormatDateToMDY(_data.checkbookDate), {
        x: 335, y: 175, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      const amount = Number(_data.totalDebitAmount || 0);
      page.drawText(_data.totalDebitAmount?.toString() ?? "", {
        x: 450, y: 175, size: 10, font: calibriFont, color: rgb(0, 0, 0),
      });

      // Amount in Words
      const whole = Math.floor(amount);
      const cents = Math.round((amount - whole) * 100);
      const words = `${toWords(whole)} ${cents > 0 ? `AND ${toWords(cents)} CENTS` : ""}`.toUpperCase();

      page.drawText(_data.totalDebitAmount?.toString() ?? "", { x: 211, y: 132, size: 12, font: calibriBold, color: rgb(0, 0, 0) });
      page.drawText(words, { x: 35, y: 109, size: 10, font: calibriBold, color: rgb(0, 0, 0) });

      // Save and Download PDF
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `Check_Voucher.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }

    setLoading(false)
  }
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasOutgoingPaymentVoucher) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl calibriFont-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Check Voucher`}
            </h2>
            <p className="text-gray-500 mt-1">An accounting document/report that records and summarizes a payment made.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm calibriFont-medium mb-1 text-gray-700 ">
              Transaction <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Transaction"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${journal ? `${journal?.documentHeaderText} - ${journal?.company?.companyName1} - ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(journal?.totalDebitAmount)}` : ""}`}
                readOnly
              />
              {!journal ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openJournalSelect}>
                  <ManageSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setJournal(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm calibriFont-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
        </div>

        <button onClick={generateHandleClick} className="mt-10 flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm calibriFont-semibold hover:bg-theme-color-h transition shadow-md">
          <RestartAltIcon fontSize="small" /> Generate
        </button>
      </div>

      <ReportsJournalSelect 
        visible={showJournalSelect} 
        onClose={closeJournalSelect}
        modalName={"Select Transaction"}
        documentTypeId={AP_DOCUMENT_TYPE}
        data={journal} setData={setJournal}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}